export var PopularDefinition = [
  {
    title: 'Tokyo',
    code: '13',
    img: '/static/images/cities/tokyo.png',
  },
  {
    title: 'Osaka',
    code: '27',
    img: '/static/images/cities/osaka.png',
  },
  {
    title: 'Kyoto',
    code: '26',
    img: '/static/images/cities/kyoto.png',
  },
  {
    title: 'Kawaguchiko',
    code: '206',
    img: '/static/images/cities/kawaguchiko.png',
  },
  {
    title: 'Tokyo Disney Resort / maihama',
    code: '180',
    img: '/static/images/cities/tokyo-disney.png',
  },
  {
    title: 'Takayama',
    code: '218',
    img: '/static/images/cities/Takayama.png',
  },
  {
    title: 'Sapporo',
    code: '110',
    img: '/static/images/cities/saporo.png',
  },
  {
    title: 'Hakata',
    code: '309',
    img: '/static/images/cities/hakata.png',
  },
  {
    title: 'Kanazawa',
    code: '235',
    img: '/static/images/cities/kanazawa.png',
  },
  {
    title: 'Hakone',
    code: '201',
    img: '/static/images/cities/hakone.png',
  },
];
export var CityDefinition = [
  {
    title: 'Sapporo',
    code: '110',
  },
  {
    title: 'Sendai',
    code: '135',
  },
  {
    title: 'Tokyo',
    code: '13',
  },
  {
    title: 'Nagoya',
    code: '223',
  },
  {
    title: 'Nagano',
    code: '20',
  },
  {
    title: 'Osaka',
    code: '27',
  },
  {
    title: 'Kyoto',
    code: '26',
  },
  {
    title: 'Kobe',
    code: '277',
  },
  {
    title: 'Kanazawa',
    code: '235',
  },
  {
    title: 'Hiroshima',
    code: '291',
  },
  {
    title: 'Fukuoka',
    code: '308',
  },
  {
    title: 'Nagasaki',
    code: '328',
  },
];
export var HistoryCityDefinition = [
  {
    title: 'Kyoto',
    code: '26',
  },
  {
    title: 'Nikko',
    code: '160',
  },
  {
    title: 'Koya-san',
    code: '258',
  },
  {
    title: 'Takayama',
    code: '218',
  },
];
export var OnsenDefinition = [
  {
    title: 'Noboribetsu',
    code: '110',
  },
  {
    title: 'Kusatsu',
    code: '164',
  },
  {
    title: 'Kinugawa',
    code: '161',
  },
  {
    title: 'Hakone',
    code: '201',
  },
  {
    title: 'Izu / Atami',
    code: '209',
  },
  {
    title: 'Kawaguchiko',
    code: '206',
  },
  {
    title: 'Arima',
    code: '275',
  },
  {
    title: 'Shirahama',
    code: '259',
  },
  {
    title: 'Kinosaki',
    code: '271',
  },
  {
    title: 'Beppu',
    code: '316',
  },
  {
    title: 'Yufuin',
    code: '315',
  },
];
